import { io, type Socket } from 'socket.io-client';
import env from '@/config/env';

/**
 * Single shared Socket.IO connection for the authenticated portal (M2 §12.1).
 * Both the notifications listener and the workflow/dashboard listener consume
 * this one instance, so the portal never opens duplicate sockets. The socket is
 * recreated only when the auth token changes, and torn down on logout via
 * closeSocket().
 */
let socket: Socket | null = null;
let currentToken: string | null = null;

export function getSocket(token: string): Socket {
  if (socket && currentToken === token) return socket;
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  currentToken = token;
  socket = io(env.WS_URL, {
    transports: ['websocket', 'polling'],
    auth: { token: `Bearer ${token}` },
  });
  return socket;
}

export function closeSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
    currentToken = null;
  }
}
